// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cgu .cheum-cgu{position:sticky;top:90px}.cgu .cheum-cgu a{font-size:0.8rem;white-space:nowrap;word-break:break-all;text-overflow:ellipsis;padding:0.1em 1em;overflow:hidden}\n", ""]);
// Exports
module.exports = exports;
